import EmailTemplate, {
  EmailTemplateFormSend,
} from "@/interfaces/EmailTemplate";
import api from "../api";
import { IPaginateResponse } from "@/interfaces/Fetch";

export const emailTemplatesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getEmailTemplates: build.query<IPaginateResponse<EmailTemplate>, void>({
      query: () => "/email-templates",
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: "EmailTemplates" as const,
                id,
              })),
              { type: "EmailTemplates", id: "LIST" },
            ]
          : [{ type: "EmailTemplates", id: "LIST" }],
    }),
    getEmailTemplate: build.query<EmailTemplate, string>({
      query: (id) => `/email-templates/${id}`,
      providesTags: (_result, _err, id) => [{ type: "EmailTemplates", id }],
    }),
    storeEmailTemplate: build.mutation<EmailTemplate, EmailTemplateFormSend>({
      query: (data) => ({
        url: "/email-templates",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [{ type: "EmailTemplates", id: "LIST" }],
    }),
    updateEmailTemplate: build.mutation<
      EmailTemplate,
      [string, EmailTemplateFormSend]
    >({
      query: ([id, data]) => ({
        url: `/email-templates/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (_result, _err, [id]) => [
        { type: "EmailTemplates", id },
        { type: "EmailTemplates", id: "LIST" },
      ],
    }),
    destroyEmailTemplate: build.mutation<void, string>({
      query: (id) => ({
        url: `/email-templates/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "EmailTemplates", id: "LIST" }],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetEmailTemplatesQuery,
  useLazyGetEmailTemplatesQuery,
  useGetEmailTemplateQuery,
  useStoreEmailTemplateMutation,
  useUpdateEmailTemplateMutation,
  useDestroyEmailTemplateMutation,
} = emailTemplatesApi;
